import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

export const PremiumWrapper = styled(Flex)`
  gap: 12px;
  flex-direction: column;
`;

export const PremiunValue = styled(Text)`
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;

   color: ${({ isDiscount }) => {
    return isDiscount ? "#0FA457" : "#040222";
  }};
    
  }}
`;

export const TextWrapper = styled(Flex)`
  width: calc(100% - 80px);
  @media (min-width: 768px) {
    width: auto;
  }
`;

export const PremiumHeading = styled(Text)`
  color: #5b5675;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

export const PlanPrice = styled(Text)`
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;
